import React from 'react';

import Input from './Input';

interface InputAffixProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  className?: string;
  type?: React.HTMLInputTypeAttribute;
  iconId?: string;
  iconClassName?: string;
  iconRef?: React.RefObject<HTMLSpanElement> | React.Ref<HTMLSpanElement>;
  errorHint?: React.ReactNode;
  errorHintId?: string;
  errorHintHidden?: boolean;
  errorHintClassName?: string;
  errorHintRef?: React.RefObject<HTMLElement> | React.Ref<HTMLElement>;
  hint?: React.ReactNode;
  hintId?: string;
  hintHidden?: boolean;
  hintClassName?: string;
  hintRef?: React.RefObject<HTMLElement> | React.Ref<HTMLElement>;
}

const InputAffix = React.forwardRef<HTMLInputElement, InputAffixProps>(
  (
    {
      label,
      className = '',
      type = 'text',
      iconId,
      iconClassName = '',
      iconRef,
      errorHint,
      errorHintId,
      errorHintHidden,
      errorHintClassName = '',
      errorHintRef,
      hint,
      hintId,
      hintHidden,
      hintClassName = '',
      hintRef,
      id,
      ...props
    },
    ref
  ) => {
    const showErrorHint = errorHint !== undefined || Boolean(errorHintId) || Boolean(errorHintRef);
    const showHint = hint !== undefined || Boolean(hintId) || Boolean(hintRef);

    return (
      <>
        {label ? <label htmlFor={id}>{label}</label> : null}
        <div className='input-affix affix'>
          <Input id={id} ref={ref} className={className} type={type} hint={undefined} {...props} />
          <span
            ref={iconRef}
            className={`affix-icon${iconClassName ? ' ' + iconClassName : ''}`}
            id={iconId}
            aria-hidden='true'
          />
        </div>
        {showErrorHint ? (
          <small
            className={`field-error error${errorHintClassName ? ' ' + errorHintClassName : ''}`}
            id={errorHintId}
            hidden={errorHintHidden}
            ref={errorHintRef}
          >
            {errorHint}
          </small>
        ) : null}
        {showHint ? (
          <small
            className={`hint${hintClassName ? ' ' + hintClassName : ''}`}
            id={hintId}
            hidden={hintHidden}
            ref={hintRef}
          >
            {hint}
          </small>
        ) : null}
      </>
    );
  }
);

InputAffix.displayName = 'InputAffix';

export default InputAffix;
